var exports = {
  "x": "x93eb46d8--22b29b--button",
};

module.exports = exports;
